/**
 * LES DEUX FORMES D'UNE ICONE, ET LA TRADUCTION ENTRE ELLES.
 *
 * LE FAIT : le registre complet (`icon-registry.tsx`) est en CLEFS KEBAB
 * (`camera-video`) ; une fiche d'app (`taki.app.json`) et un brief de Studio
 * portent le NOM DU COMPOSANT (`IconCameraVideo`). Le shell derive l'icone du
 * dock de la fiche, le Studio l'y ecrit : les deux passent par ici.
 *
 * ICI ET NULLE PART AILLEURS, et sans un seul import : la regle se prouve en
 * `node --test` sur le `dist/` (`packages/ui/tests/icones.test.mjs`), la ou une
 * conversion enfermee dans un composant ne se verifierait qu'a l'oeil.
 *
 * LE GARDE-FOU DE LA FICHE N'EXIGEAIT QU'UNE CHAINE NON VIDE : une clef kebab
 * ecrite la y serait restee sans que rien ne la refuse. C'est
 * `scripts/check-app-entities.mjs` qui refuse desormais un nom que le dock ne
 * sait pas resoudre.
 */

/** Ce que le moteur pose quand l'icone est vide (`iconComponentName`). */
export const ICONE_PAR_DEFAUT = 'contact-book';

/**
 * `camera-video` -> `IconCameraVideo`.
 *
 * C'est mot pour mot le `toPascalName` qui a GENERE les composants
 * (`tools/gen-icons.mjs`) et le `iconComponentName` que le moteur applique a la
 * creation : trois ecritures du meme fait divergeraient, donc celle-ci ne
 * devine rien, elle rejoue la regle de generation.
 */
export function composantDIcone(clef: string): string {
  const corps = clef
    .split(/[^a-zA-Z0-9]+/)
    .filter(Boolean)
    .map((segment) => segment.charAt(0).toUpperCase() + segment.slice(1))
    .join('');
  return corps === '' ? '' : 'Icon' + corps;
}

/**
 * `IconCameraVideo` -> `camera-video`, CHERCHE dans le registre et jamais
 * deduit a l'envers : c'est la seule facon d'etre exact.
 *
 * Rend `''` quand aucune clef ne produit ce nom. Ca arrive vraiment : dix noms
 * historiques sont des ALIAS d'une autre clef (`IconContact` pointe sur
 * `contact-book`, `IconHome` sur `home-1`, `tools/gen-icons.mjs`). L'ecran le
 * DIT au lieu de pretendre que l'icone n'existe pas, et la saisie libre garde la
 * valeur telle quelle ; le dock, lui, resout ces dix noms par sa map curatee.
 */
export function clefDIcone(nom: string, registre: Record<string, string> | null): string {
  const cherche = nom.trim();
  if (cherche === '' || registre == null) return '';
  return Object.keys(registre).find((clef) => composantDIcone(clef) === cherche) ?? '';
}

/** Ce que la valeur EST : la clef du registre (le brief), ou le nom du composant (la fiche). */
export type FormeIcone = 'clef' | 'composant';
